import { render, staticRenderFns } from "./ProjectForumSection.vue?vue&type=template&id=0efe2782&scoped=true"
import script from "./ProjectForumSection.vue?vue&type=script&lang=ts"
export * from "./ProjectForumSection.vue?vue&type=script&lang=ts"
import style0 from "./ProjectForumSection.vue?vue&type=style&index=0&id=0efe2782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efe2782",
  null
  
)

export default component.exports